module.exports = __webpack_public_path__ + "img/wild.7589025c.png";